'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _domain = require('@marmalade/domain');
var _domain2 = _interopRequireDefault(_domain);
var _radio = require('../components/radio');
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
MarketingOptIn.propTypes = {
  label: _propTypes.element
};
MarketingOptIn.defaultProps = {
  label: _react2.default.createElement('span', null, "We'd like to keep you updated with tips to help you on your driving journey, news about Marmalade products, and exciting offers too \u2013 this could be by email, post, messaging or online. We'll send you a link so you can update your contact preferences, or unsubscribe, at any time. Find out more in our", ' ', _react2.default.createElement('a', {
    href: (0, _domain2.default)('www.wearemarmalade') + '/about-us/your-data-privacy',
    target: '_blank'
  }, 'privacy policy'), '.')
};
function MarketingOptIn(props) {
  return _react2.default.createElement(_radio.RadioYesNo, {
    name: 'marketingOptIn',
    label: props.label
  });
}
exports.default = MarketingOptIn;